<template>
    <div class="slider-wrapper">
        <div class="slider-content" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd">
            <slot></slot>
        </div>
        <div class="slider-contro clearfix" v-show="hasSlider">
            <transition name="fade">
                <div v-show="needSlide && moving && slideType === 'touch'" class="contro-item"></div>
            </transition>
            <span v-show="detailMode && (needSlide || prePage) && slideType === 'click'" :class="['slider-prev', {'disabled': offsetX === 0 && !prePage}]" @click="slidePrev"></span>
            <slot name = 'slider-control'></slot>
            <i v-show="detailMode && (needSlide || prePage) && slideType === 'click' && offsetX < 0" class="slider-prev-mask"></i>
            <span v-show="detailMode && (needSlide || nextPage) && slideType === 'click'" :class="['slider-next', {'disabled': offsetX === sliderMax && !nextPage}]" @click="slideNext"></span>
            <i v-show="detailMode && (needSlide || nextPage) && slideType === 'click' && offsetX > sliderMax" class="slider-next-mask"></i>
        </div>
    </div>
</template>

<script>
import Bus from '../utils/event-bus';
import {RESET_SLIDER_STAT, SLIDER_TO_INDEX, SLIDER_TO_END} from '../utils/event-names';

let loaded = false;
export default {
    data() {
        return {
            startX: 0,
            startStamp: 0,
            moveStamp: 0,
            moving: false,
            distanceX: 0,
            offsetX: 0,
            wrapperW: 0,
            contentW: 0,
            timer: null
        };
    },
    props: {
        autoIndex: {
            type: Number,
            default: 0
        },
        length: {
            type: Number,
            required: true
        },
        slideType: {
            type: String,
            default: 'touch'
        },
        canReset: {
            type: Boolean,
            default: false
        },
        canEnd: {
            type: Boolean,
            default: false
        },
        skew: { // 单次滚动的偏移量
            type: Number,
            default: 0
        },
        disabledResize: { // 禁止resize时候重置滚动条
            type: Boolean,
            default: false
        },
        prePage: {
            type: Boolean,
            default: false
        },
        nextPage: {
            type: Boolean,
            default: false
        },
        detailMode: {
            type: Boolean,
            default: true
        },
        hasSlider: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        sliderMax() {
            return this.wrapperW - this.contentW;
        },
        needSlide() {
            return this.contentW > this.wrapperW;
        },
        slideWidth() {
            return this.wrapperW - this.skew;
        }
    },
    watch: {
        autoIndex() {
            this.$nextTick(function() {
                this.handerResize();
            });
        },
        distanceX() {
            let transDistance = this.offsetX + this.distanceX;
            transDistance = transDistance <= 0 ? transDistance : 0;
            transDistance = transDistance >= this.sliderMax ? transDistance : this.sliderMax;
            if (this.distanceX !== 0) {
                this.moving = true;
                this.moveContent(transDistance);
            }
        }
    },
    mounted() {
        if (this.canReset) {
            Bus.$on(RESET_SLIDER_STAT, () => {
                if (this.$el.children[0].children[0]) {
                    this.$el.children[0].children[0].style.transition = 'none';
                    this.moveContent(0, true);
                    this.offsetX = 0;
                    setTimeout(() => {
                        this.$el.children[0].children[0].style.transition = 'transform .3s ease';
                    }, 100);
                }
            });
            Bus.$on(SLIDER_TO_INDEX, () => {
                if (this.autoIndex > 0) {
                    let eachWidth = this.contentW / this.length;
                    let indexOffsetX = -eachWidth * (this.autoIndex - 0.2);
                    this.offsetX = indexOffsetX < this.sliderMax ? this.sliderMax : indexOffsetX;
                    this.moveContent(this.offsetX);
                } else {
                    if (this.$el.children[0].children[0]) {
                        this.$el.children[0].children[0].style.transition = 'none';
                        this.moveContent(0, true);
                        this.offsetX = 0;
                        setTimeout(() => {
                            this.$el.children[0].children[0].style.transition = 'transform .3s ease';
                        }, 100);
                    }
                }
            });
        }
        if (this.canEnd) {
            Bus.$on(SLIDER_TO_END, () => {
                if (this.$el.children[0].children[0]) {
                    this.$el.children[0].children[0].style.transition = 'none';
                    this.moveContent(this.sliderMax, true);
                    this.offsetX = this.sliderMax;
                    setTimeout(() => {
                        this.$el.children[0].children[0].style.transition = 'transform .3s ease';
                    }, 100);
                }
            });
        }
        this.wrapperW = this.$el.offsetWidth;
        window.addEventListener('resize', this.handerResize, false);
    },
    updated() {
        if (this.detailMode) {
            this.contentW = this.$el.children[0].children[0].scrollWidth;
            if (!loaded && this.needSlide && this.autoIndex > 0) {
                let eachWidth = this.contentW / this.length;
                let indexOffsetX = -eachWidth * (this.autoIndex - 0.2);
                this.offsetX = indexOffsetX < this.sliderMax ? this.sliderMax : indexOffsetX;
                this.moveContent(this.offsetX);
                loaded = true;
            }
            this.$emit('ready', this.needSlide);
        }
    },
    methods: {
        handerResize() {
            if (this.detailMode) {
                this.wrapperW = this.$el.offsetWidth;
                this.contentW = this.$el.children[0].children[0].scrollWidth;
                if (this.needSlide && this.autoIndex > 0) {
                    let eachWidth = this.contentW / this.length;
                    let indexOffsetX = -eachWidth * (this.autoIndex - 0.2);
                    this.offsetX = indexOffsetX < this.sliderMax ? this.sliderMax : indexOffsetX;
                    this.moveContent(this.offsetX);
                } else if (this.needSlide && !this.disabledResize) {
                    this.offsetX = 0;
                    this.moveContent(0);
                }
            }
        },
        touchStart(e) {
            if (this.slideType === 'touch') {
                this.clearTimer();
                this.initData();
                if (this.needSlide && e.touches.length === 1) { // 单个手指才算滚动
                    document.body.addEventListener('touchmove', this.preventScroll, window.supportPassive ? { passive: false } : false);
                    this.startStamp = e.timeStamp;
                    this.startX = e.touches[0].clientX;
                }
            }
        },
        touchMove(e) {
            if (this.needSlide && this.startX !== 0 && this.slideType === 'touch') {
                this.moveStamp = e.timeStamp;
                this.distanceX = e.changedTouches[0].clientX - this.startX;
            }
        },
        touchEnd(e) {
            if (this.slideType === 'touch') {
                if (this.needSlide && e.timeStamp - this.moveStamp < 30) { // 自动滚动
                    let speed = this.distanceX / (e.timeStamp - this.startStamp);
                    this.autoSlide(speed, () => {
                        this.initData();
                    });
                } else {
                    this.initData();
                }
                document.body.removeEventListener('touchmove', this.preventScroll, window.supportPassive ? { passive: false } : false);
            }
        },
        slidePrev() {
            // 滑动过程中不允许点击
            if (this.timer) return;
            this.$emit('clickpre');
            if (this.offsetX < 0 && this.timer === null) {
                this.distanceX = this.slideWidth;
                this.timer = setTimeout(() => {
                    this.offsetX += this.slideWidth;
                    if (this.offsetX > 0) {
                        this.offsetX = 0;
                    }
                    this.distanceX = 0;
                    this.clearTimer();
                }, 300);
            } else if (this.prePage) {
                this.$emit('pagepre');
            }
        },
        slideNext() {
            // 滑动过程中不允许点击
            if (this.timer) return;
            this.$emit('clicknext');
            if (this.offsetX > this.sliderMax && this.timer === null) {
                this.distanceX = -this.slideWidth;
                this.timer = setTimeout(() => {
                    this.offsetX -= this.slideWidth;
                    if (this.offsetX < this.sliderMax) {
                        this.offsetX = this.sliderMax;
                    }
                    this.distanceX = 0;
                    this.clearTimer();
                }, 300);
            } else if (this.nextPage) {
                this.$emit('pagenext');
            }
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = null;
        },
        autoSlide(speed, callback) {
            if (!this.timer) {
                let initSpeed = Math.abs(speed);
                this.timer = setInterval(() => {
                    if (speed > 0) {
                        this.distanceX = this.distanceX + speed * 35;
                        speed = speed - initSpeed / 35;
                        if (speed <= 0) speed = 0;
                    } else if (speed < 0) {
                        this.distanceX = this.distanceX + speed * 35;
                        speed = speed + initSpeed / 35;
                        if (speed >= 0) speed = 0;
                    } else {
                        callback && callback();
                        this.clearTimer();
                    }
                }, 10);
            }
        },
        moveContent(transDistance, noAnime) {
            if (this.$el.children[0].children[0]) {
                this.$el.children[0].children[0].style.transform = `translateX(${transDistance}px)`;
                this.$el.children[0].children[0].style.webkitTransform = `translateX(${transDistance}px)`;
            }
            this.$el.children[1].children[0].style.left = `${transDistance / this.sliderMax * (this.wrapperW - 90)}px`;
        },
        initData() {
            this.startStamp = 0;
            this.moveStamp = 0;
            let transDistance = this.offsetX + this.distanceX;
            if (this.distanceX > 0) {
                this.offsetX = transDistance <= 0 ? transDistance : 0;
            } else {
                this.offsetX = transDistance >= this.sliderMax ? transDistance : this.sliderMax;
            }
            this.distanceX = 0;
            this.startX = 0;
            this.moving = false;
        },
        preventScroll(e) {
            if (e.cancelable && !e.defaultPrevented) {
                e.preventDefault();
            }
        },
        moveTostart() {
            if (this.$el.children[0].children[0]) {
                this.$el.children[0].children[0].style.transition = 'none';
                this.moveContent(0, true);
                this.offsetX = 0;
                setTimeout(() => {
                    this.$el.children[0].children[0].style.transition = 'transform .3s ease';
                }, 100);
            }
        }
    }
};
</script>

<style lang="less">
@px2rem: 320 / 750 / 20;

.slider-wrapper {
    position: relative;
    width: 100%;
    .slider-content {
        overflow: hidden;
        li {
            margin-bottom: 0!important;
        }
    }
    .slider-contro {
        height: unit(5 * @px2rem, rem);
        position: relative;
        .slider-prev-mask, .slider-next-mask {
            display: none;
        }
        .contro-item {
            position: absolute;
            top: 0;
            min-width: 5px;
            width: 90px;
            height: unit(5 * @px2rem, rem);
            border-radius: unit(3 * @px2rem, rem);
            background-color: rgba(0,0,0,.2);
        }
    }
}
</style>
